// États d'interface : chargement (squelettes), erreur, succès, absence de données (« indisponible » et motif).

import type { ReactNode } from 'react';
import { messageErreur } from '../api/client';

export function Squelette({ lignes = 3, libelle = 'Chargement en cours' }: { lignes?: number; libelle?: string }) {
  return (
    <div role="status" aria-live="polite" aria-busy="true">
      <span className="visuellement-cache">{libelle}</span>
      {Array.from({ length: lignes }, (_, i) => (
        <div key={i} className="squelette" style={{ width: `${90 - ((i * 17) % 40)}%` }} />
      ))}
    </div>
  );
}

export function MessageErreur({ erreur, titre = 'Une erreur est survenue' }: { erreur: unknown; titre?: string }) {
  return (
    <div className="message erreur" role="alert">
      <strong>{titre}</strong>
      <div>{messageErreur(erreur)}</div>
    </div>
  );
}

export function Message({ type, children }: { type: 'succes' | 'info' | 'avertissement' | 'erreur'; children: ReactNode }) {
  return (
    <div className={`message ${type}`} role={type === 'erreur' ? 'alert' : 'status'}>
      {children}
    </div>
  );
}

/** Valeur absente : jamais affichée comme 0, toujours avec son motif. */
export function Indisponible({ motif }: { motif: string }) {
  return (
    <span className="indisponible">
      indisponible
      <span className="motif">{motif}</span>
    </span>
  );
}

export function Vide({ children }: { children: ReactNode }) {
  return <p className="attenue">{children}</p>;
}
